module.exports = __webpack_public_path__ + "img/電気回路_1_8_4.9ce36a6c.png";